// @flow
import type {AxiosPromise} from 'axios';

import type {ActionType} from 'constants/flow/flowTypes';
import {PRODUCT} from 'constants/actions';

import type {DiscountPriceType, DiscountPriceResponseType} from './discountPriceType';

export const initialState: DiscountPriceType = {
    status: '',
    coupon: '',
    price: 0,
    finalPrice: 0,
};

/**
 * Provides the discount price store on pdp
 * @param {DiscountPriceType} state - reducer state
 * @param {ActionType} action - dispatched action
 * @return {DiscountPriceType} new reducer state
 */
export function discountPrice(
    state: DiscountPriceType = initialState,
    action: ActionType<AxiosPromise<DiscountPriceResponseType>>,
): DiscountPriceType {
    switch (action.type) {
        case `${PRODUCT.GET_DISCOUNT_PRICE}_PENDING`: {
            return {...initialState, status: 'pending'};
        }

        case `${PRODUCT.GET_DISCOUNT_PRICE}_FULFILLED`: {
            if (!action.payload) {
                // request was cancelled
                return state;
            }
            return {
                ...state,
                ...action.payload.data,
                status: 'fulfilled',
            };
        }

        case PRODUCT.SET_ACTIVE_PRODUCT_ID: {
            return initialState;
        }

        default:
            return state;
    }
}
